export default {
  sections: {
    alcohol_percentage: 'Alcohol content: {{value}}%',
    price_per_unit: 'Price per {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingredients',
    allergens: 'Allergens',
    additives: 'Additives',
    nutrition_breakdown: {
      title: 'Nutritional information',
      description: '100 {{unit}} contains:',
      items: {
        energy: 'Energy',
        fat: 'Fat',
        saturates: 'of which saturated fatty acids',
        carbohydrates: 'Carbohydrates',
        sugars: 'of which sugar',
        protein: 'Protein',
        salt: 'Salt',
      },
    },
  },
  units: {
    l: 'liter',
    kg: 'kilo',
    default: 'unit',
  },
};
